import Vue from 'vue'
import store from '..'
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  namespaced: true,
  state () {
    return {
      metrics: [],
      reference: null,
      initial: {
        key: null,
        0: {},
        1: {},
        2: {},
        3: {},
        4: {},
        5: {},
        6: {},
        7: {},
        8: {},
        9: {},
        10: {},
        11: {},
        year: null,
        schools: {},
        groups: {},
        author: null,
        createdAt: null,
        updatedAt: null
      },
      headers: [
        { key: 17, name: '合計', type: 'header' },
        { key: 14, name: '小学部', type: 'header' },
        { key: 1, name: '小1', type: 'S', sufix: '人' },
        { key: 2, name: '小2', type: 'S', sufix: '人' },
        { key: 3, name: '小3', type: 'S', sufix: '人' },
        { key: 4, name: '小4', type: 'S', sufix: '人' },
        { key: 5, name: '小5', type: 'S', sufix: '人' },
        { key: 6, name: '小6', type: 'S', sufix: '人' },
        { key: 15, name: '中学部', type: 'header' },
        { key: 7, name: '中1', type: 'J', sufix: '人' },
        { key: 8, name: '中2', type: 'J', sufix: '人' },
        { key: 9, name: '中3', type: 'J', sufix: '人' },
        { key: 16, name: '高校部', type: 'header' },
        { key: 10, name: '高1', type: 'H', sufix: '人' },
        { key: 11, name: '高2', type: 'H', sufix: '人' },
        { key: 12, name: '高3', type: 'H', sufix: '人' },
        { key: 13, name: '既卒', type: 'H', sufix: '人' }
      ],
      preHeader: { key: 0, name: '幼児', type: 'header' },
      preHeader_extension_1: [
        { key: 17, name: '合計', type: 'header' },
        { key: 30, name: '幼児', type: 'header' },
        { key: 26, name: '3歳', type: 'Y', sufix: '人' },
        { key: 27, name: '4歳', type: 'Y', sufix: '人' },
        { key: 28, name: '5歳', type: 'Y', sufix: '人' },
        { key: 29, name: '6歳', type: 'Y', sufix: '人' },
        { key: 14, name: '小学部', type: 'header' },
        { key: 1, name: '小1', type: 'S', sufix: '人' },
        { key: 2, name: '小2', type: 'S', sufix: '人' },
        { key: 3, name: '小3', type: 'S', sufix: '人' },
        { key: 4, name: '小4', type: 'S', sufix: '人' },
        { key: 5, name: '小5', type: 'S', sufix: '人' },
        { key: 6, name: '小6', type: 'S', sufix: '人' },
        { key: 15, name: '中学部', type: 'header' },
        { key: 7, name: '中1', type: 'J', sufix: '人' },
        { key: 8, name: '中2', type: 'J', sufix: '人' },
        { key: 9, name: '中3', type: 'J', sufix: '人' },
        { key: 16, name: '高校部', type: 'header' },
        { key: 10, name: '高1', type: 'H', sufix: '人' },
        { key: 11, name: '高2', type: 'H', sufix: '人' },
        { key: 12, name: '高3', type: 'H', sufix: '人' },
        { key: 13, name: '既卒', type: 'H', sufix: '人' }
      ]
    }
  },
  getters: {
    metrics (state) {
      return state.metrics
    },
    reference (state) {
      return state.reference
    },
    initial (state) {
      return state.initial
    },
    headers (state) {
      return state.headers
    },
    preHeader (state) {
      return state.preHeader
    },
    preHeader_extension_1 (state) {
      return state.preHeader_extension_1
    }
  },
  mutations: {
    init (state, payload) {
      state.metrics = payload
    },
    add (state, payload) {
      state.metrics.push(payload)
    },
    update (state, payload) {
      const index = state.metrics.findIndex(metric => metric.key === payload.key)
      if (index !== -1) {
        Vue.set(state.metrics, index, payload)
      }
    },
    remove (state, payload) {
      const index = state.metrics.findIndex(metric => metric.key === payload.key)
      if (index !== -1) {
        state.metrics.splice(index, 1)
      }
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({ commit }) {
      return new Promise((resolve) => {
        commit('init', [])
        resolve()
      })
    },
    subscribe ({ commit }, payload) {
      var boot = true
      var temp = []
      return new Promise((resolve, reject) => {
        commit('init', [])
        const db = firebase.firestore()
        var dbRef = db.collection('metrics_revises')
        var reference = null
        if (payload) {
          reference = dbRef.where('schools.' + payload, '==', true).onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              var data = JSON.parse(JSON.stringify(change.doc.data()))
              if (boot && change.type === 'added') {
                temp.push(data)
              } else if (change.type === 'added') {
                commit('add', data)
              } else if (change.type === 'modified') {
                commit('update', data)
              } else if (change.type === 'removed') {
                commit('remove', data)
              }
            })
            if (boot) {
              boot = false
              commit('init', temp)
            }
            resolve()
          })
        } else {
          reference = dbRef.onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              var data = JSON.parse(JSON.stringify(change.doc.data()))
              if (boot && change.type === 'added') {
                temp.push(data)
              } else if (change.type === 'added') {
                commit('add', data)
              } else if (change.type === 'modified') {
                commit('update', data)
              } else if (change.type === 'removed') {
                commit('remove', data)
              }
            })
            if (boot) {
              boot = false
              commit('init', temp)
            }
            resolve()
          })
        }
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      var reference = store.getters['metricsRevises/reference']
      return new Promise((resolve) => {
        if (reference) {
          reference()
          commit('reference', null)
          commit('init', [])
          resolve()
        } else {
          resolve()
        }
      })
    },
    write ({ commit }, payload) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        var ref = null
        if (payload.key) {
          ref = db.collection('metrics_revises').doc(payload.key)
        } else {
          ref = db.collection('metrics_revises').doc()
          payload.key = ref.id
        }
        ref.set(payload)
          .then(function () {
            const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
            pause(0).then(() => {
              console.log('Document successfully written!')
              resolve()
            })
          })
          .catch(function (error) {
            console.error('Error writing document: ', error)
            resolve()
          })
      })
    },
    delete ({ commit }, payload) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        db.collection('metrics_revises').doc(payload).delete().then(function () {
          console.log('Document successfully deleted!')
          resolve()
        }).catch(function (error) {
          console.error('Error removing document: ', error)
          resolve()
        })
      })
    }
  }
}
